/**
 * Kyrgyzstani som.
 */
export var KGS = {
  code: 'KGS',
  base: 10,
  exponent: 2
};